import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import MboxItem from './MboxItem'
import QuicklinkItem from './QuicklinkItem/QuicklinkItem'
import MobileUploadItem from './MobileUploadItem'

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.accent,
        padding: theme.spacing(2),
        marginTop: theme.spacing(2),
        borderRadius: 12
    }
}))

const ListItem = ({ type, ...props }) => {
    const classes = useStyles()
    const item = {
        mbox: () => <MboxItem {...props} />,
        quicklink: () => <QuicklinkItem {...props} />,
        mobileUpload: () => <MobileUploadItem {...props} />
    }

    return <Box className={classes.root}>{item[type]()}</Box>
}

ListItem.propTypes = {
    complexity: PropTypes.string,
    value: PropTypes.number,
    avgLength: PropTypes.number,
    profiles: PropTypes.number,
    onChange: PropTypes.func.isRequired,
    remove: PropTypes.func.isRequired,
    factor: PropTypes.any
}

export default ListItem
